// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__1C2eI","header":"styles_header__1grs3","back":"styles_back__2Zt9h","title":"styles_title__2SDON","content":"styles_content__12NTq"};